import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  root: {
    width: 20,
    height: 20,
    objectFit: 'contain',
  },
});
